export const LANGUAGE_ALL = {
  id: 0,
  title: 'All Languages',
  analyticsTitle: 'all',
  description: '',
  seoDescription: '',
}

export const GENRE_ALL = {
  id: 0,
  title: 'All Genres',
  analyticsTitle: 'all',
  description: '',
  seoDescription: '',
}
